/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { media } from '@atlassian/bitkit-responsive';

export const OnboardingDialogContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

export const OnboardingDialogBodyContainer = styled.div(
  {
    width: '100%',
    overflow: 'hidden',
    flexBasis: `${gridSize() * 55}px`,
  },
  media.upToMedium(`
    flex-basis: initial;
  `)
);

export const OnboardingDialogBannerImage = styled.img({
  width: '100%',
});

export const OnboardingDialogFooterContainer = styled.div(
  {
    padding: `${gridSize() * 5}px ${gridSize() * 3}px`,
  },
  media.upToMedium(`
    padding: ${gridSize() * 3}px ${gridSize() * 1}px;
  `)
);

export const OnboardingDialogFooterTitle = styled.h3(
  {
    textAlign: 'center',
    marginBottom: `${gridSize() * 4}px`,
  },
  media.upToMedium(`
    margin-bottom: ${gridSize() * 2}px;
  `)
);

export const OnboardingDialogFooterDescription = styled.p({
  textAlign: 'center',
  minHeight: `${gridSize() * 5}px`,
});

export const OnboardingDialogFooterActionsContainer = styled.div(
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: `${gridSize() * 5}px`,
  },
  media.upToMedium(`
    margin-top: ${gridSize() * 3}px;
  `)
);

export const OnboardingDialogFooterActionButtonLeft = styled.div({
  display: 'flex',
  justifyContent: 'flex-start',
  width: `${gridSize() * 10}px`,
});

export const OnboardingDialogFooterActionButtonRight = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  width: `${gridSize() * 10}px`,
});
